import styled, {keyframes} from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const CustomLoaderIconContainer = styled.div`
  animation: ${spin} 1s linear infinite;
  width: 33px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
`;